// extracted by mini-css-extract-plugin
export var countryCode = "SingleScreenPopupWithMobile-module--countryCode--dHd6F";
export var coupon = "SingleScreenPopupWithMobile-module--coupon--Hueib";
export var cross = "SingleScreenPopupWithMobile-module--cross--s1lZd";
export var customFont = "SingleScreenPopupWithMobile-module--customFont--jbMeG";
export var cyberSalePhoneInput = "SingleScreenPopupWithMobile-module--cyberSalePhoneInput--DOqzy";
export var diwaliSalePhoneInput = "SingleScreenPopupWithMobile-module--diwaliSalePhoneInput--uFc5g";
export var email = "SingleScreenPopupWithMobile-module--email--wHOv2";
export var modal = "SingleScreenPopupWithMobile-module--modal--viLPG";